import { Component, OnInit } from '@angular/core';
import { ApplicationTestService } from '../../services/applicationTestService';
import { MenuLoaderService } from '../../services/menu-loader.service';
import { AccountApplicationLookupItem, AccountType } from '../../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/models';
import { Router } from '@angular/router';

@Component({
	selector: 'app-application-list',
	templateUrl: './application-list.component.html',
	styleUrls: ['./application-list.component.scss'],
})
export class ApplicationListComponent implements OnInit {
	public accountApplicationAccountTypes: AccountType[] = [];
	public accountApplicationAccountPartyTypes: AccountApplicationLookupItem[] = [];
	public accountApplicationLinks: Record<string, any[]> = {};
	constructor(
		private testService: ApplicationTestService,
		private service: MenuLoaderService,
		private router: Router
	) {}

	async ngOnInit(): Promise<void> {
		await this.prepareApplicationLink();
	}

	public async prepareApplicationLink(): Promise<void> {
		this.accountApplicationAccountTypes = await this.service.fetchAllAccountTypes();
		this.accountApplicationAccountPartyTypes = await this.service.fetchAllAccountPartyTypes();
		const accountPartyWithPOD = this.accountApplicationAccountPartyTypes.find((item) => item.systemCode === 'SINGLE_PARTY_WITH_POD');
		const accountPartyWithoutPOD = this.accountApplicationAccountPartyTypes.find((item) => item.systemCode === 'SINGLE_PARTY_WITHOUT_POD');
		for (const accountType of this.accountApplicationAccountTypes) {
			switch (accountType.systemCode) {
				case 'MONEY_MARKET':
					this.accountApplicationLinks['Money Market w/POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Money Market without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'HIGH_YIELD_MONEY_MARKET':
					this.accountApplicationLinks['High Yield Money Market w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['High Yield Money Market without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'VALUE_CHECKING':
					this.accountApplicationLinks['Value Checking w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Value Checking without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'PERSONAL_CHECKING':
					this.accountApplicationLinks['Personal Checking w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Personal Checking without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'INTEREST_CHECKING':
					this.accountApplicationLinks['Interest Checking w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Interest Checking without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'PREMIUM_CHECKING':
					this.accountApplicationLinks['Premium Checking w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Premium Checking without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'SAVINGS':
					this.accountApplicationLinks['Savings w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Savings without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				case 'GATEWAY_CHECKING':
					this.accountApplicationLinks['Gateway Checking w/ POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithPOD?.entityKey,
							},
						},
					];
					this.accountApplicationLinks['Gateway Checking without POD'] = [
						'/accountopening/dashboard',
						{
							queryParams: {
								type: accountType?.accountTypeGUID,
								accountParty: accountPartyWithoutPOD?.entityKey,
							},
						},
					];
					break;
				default:
					continue;
			}
		}
	}

	public navigateTo(applicationLinkCode: string) {
		const link = this.accountApplicationLinks[applicationLinkCode];
		if (link) {
			this.router.navigate([`${link[0]}`], {
				queryParams: {
					type: link[1].queryParams.type,
					accountParty: link[1].queryParams.accountParty,
				},
			});
		}
	}
}
